var has_loaded=false;
var ready = function() {
  if(!has_loaded){
    has_loaded=true;

    require('es6-promise/auto')
    require('whatwg-fetch')

    const Uppy = require('@uppy/core');
    const ProgressBar = require('@uppy/progress-bar');
    const DragDrop = require('@uppy/drag-drop');
    const AwsS3 = require('./uppy/aws_s3_proxy');

    lang_id = $('#page_lang')[0].attributes['name'].value;
    if (lang_id == '4'){Languaged = require('@uppy/locales/lib/en_US');}
    else if (lang_id == '5'){Languaged = require('@uppy/locales/lib/zh_CN');}
    else if (lang_id == '6'){Languaged = require('@uppy/locales/lib/ja_JP');}
    else if (lang_id == '7'){Languaged = require('@uppy/locales/lib/de_DE');}
    else if (lang_id == '8'){Languaged = require('@uppy/locales/lib/es_ES');}
    else if (lang_id == '9'){Languaged = require('@uppy/locales/lib/fr_FR');}
    else if (lang_id == '10'){Languaged = require('@uppy/locales/lib/pt_BR');}
    else if (lang_id == '11'){Languaged = require('@uppy/locales/lib/it_IT');}
    else if (lang_id == '12'){Languaged = require('@uppy/locales/lib/ru_RU');}
    else if (lang_id == '13'){Languaged = require('@uppy/locales/lib/zh_TW');}
    else if (lang_id == '14'){Languaged = require('@uppy/locales/lib/cs_CZ');}
    else if (lang_id == '15'){Languaged = require('@uppy/locales/lib/tr_TR');}
    else if (lang_id == '16'){Languaged = require('@uppy/locales/lib/fi_FI');}
    else if (lang_id == '19'){Languaged = require('@uppy/locales/lib/ar_SA');}
    else if (lang_id == '20'){Languaged = require('@uppy/locales/lib/nl_NL');}
    else {Languaged = require('@uppy/locales/lib/en_US');}
 
    const uppyThree = new Uppy({debug: false, autoProceed: false, locale: Languaged, restrictions: {maxFileSize: 1024 * 1024 * 300, allowedFileTypes: ['.pptx', '.docx', '.xlsx', '.PPTX', '.DOCX', '.XLSX']}})
        .use(ProgressBar, { target: '.Uppy-Progress', hideAfterFinish: false })
        .use(DragDrop, {
            target: '.UppyDragDrop', width: '100%', height: '100%', note: '300MB or less', locale: {}
        })
        .use(AwsS3, {
            companionUrl: '/', // will call Shrine's presign endpoint on '/s3/params'
            limit: 10
        });
    uppyThree.on('file-added', (file) => {        
        $('.uploaded-files ul')[0].innerHTML += '<li>'+file.name+'</li>'
        $('#step1-div').fadeOut(500, function(){
            $('#step2-div').fadeIn(500);
        });        
    })    
    uppyThree.on('upload-success', function (file, data) {
        // construct uploaded file data in the format that Shrine expects
        var uploadedFileData = JSON.stringify({        
            id: file.meta['key'].match(/^cache\/(.+)/)[1], // object key without prefix
            storage: 'cache',
            metadata: {
                size:      file.size,
                filename:  file.name,
                mime_type: file.type,
            }
        })
        $('#document_doc')[0].value = uploadedFileData;

        if (file.size > 0){
            $.ajax({
                type: 'POST',
                dataType: 'script',
                data: {
                    document: {
                        doc: $('#document_doc')[0].value,
                        targ_id: $('.targ_lang')[0].attributes['name'].value,
                        src_id: $('.src_lang')[0].attributes['name'].value,
                        doc_type: 1,
                        lang_id: $('#page_lang')[0].attributes['name'].value,
                    },
                    email: $('#email')[0].value,
                    authenticity_token: $('meta[name ="csrf-token"]')[0].content,
                },      
                url: '/documents',
                complete: function(data){},    
            });  
        } else {location.reload();}
    })
    uppyThree.on('upload-error', (file, error) => {
        console.log('error with file:', file.id);
        console.log('error message:', error);
        $('div.Uppy-Progress > div > div.uppy-ProgressBar-inner').css('width', '0%');
    })
    uppyThree.on('file-added', (file) => {
        $('div.Uppy-Progress > div > div.uppy-ProgressBar-inner').css('width', '20%');
    })
    uppyThree.on('complete', function () {
        uppyThree.reset();
    })

    const uploadBtn = document.querySelector('button.submit-button')
    uploadBtn.addEventListener('click', function () {
        if (!(/(.+)@(.+){2,}\.(.+){2,}/.test($('#email')[0].value))) {            
            $('#email').css('border-color','red');
        } else {
            uppyThree.upload();
            uploadBtn.disabled = true;
        }
    })
  }
}


$(document).ready(ready);
$(document).on('turbolinks:load', ready);
